import DesktopSetup from "./views/desktop/PluginSetup.js";
/* eslint-disable react/jsx-filename-extension */
function processRelationshipBulk(molten, relationship, options) {
  const {
    attribute,
    parentBlueprint,
    blueprint,
    path
  } = relationship || {};
  if (!attribute?.isOneToOne() || !attribute?.hasTag('is:bulkPairing')) {
    return;
  }
  DesktopSetup.installBulk(molten, {
    attribute,
    parentBlueprint,
    blueprint,
    path,
    relationship
  });
}
export default {
  install(molten) {
    molten.addPlugin('Molten.blueprintRelationshipProcessor', {
      type: 'api-pairing.BulkPairUnpairActionCreator',
      processRelationship: processRelationshipBulk
    });
  }
};